import type { ConfigurationVersion } from "../types/editingHistoryState.types.ts";
import type { RootState } from "../types/store.types.ts";
import { selectFieldsStateConfigurationSafe, selectReportType } from "./fieldsStateSelectors.ts";

export const selectCanUndo = (state: RootState): boolean =>
  !state.uiSettings.editDisabled && state.editingHistory.index > 0;

export const selectCanRedo = (state: RootState): boolean =>
  !state.uiSettings.editDisabled && state.editingHistory.index < state.editingHistory.versions.length - 1;

export const selectLiveConfigurationVersion = (state: RootState): ConfigurationVersion | undefined => {
  const reportType = selectReportType(state);
  const configuration = selectFieldsStateConfigurationSafe(state);
  return reportType && configuration ? { configuration, reportType, dataSetId: state.metaData.dataSetId } : undefined;
};
